import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/OrderPlannerDelivery';
import StarRatingComponent from 'react-star-rating-component';
import Parser from 'html-react-parser';
import './OrderDataReview.css';

export class OrderDataReview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mobileView: window.innerWidth < 768,
            tabletView: window.innerWidth <= 1254 && window.innerWidth >= 768,
            windowWidth: window.innerWidth
        };
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize(true);
    }

    resize(skip) {
        // We only want to resize if the width changes so the Android 
        // keyboard doesn't disappear on inputs from the vertical height change
        if (window.innerWidth !== this.state.windowWidth || skip === true) {
            this.setState({ mobileView: window.innerWidth < 768 }, this.setState({ tabletView: window.innerWidth <= 1254 && window.innerWidth >= 768 }));
            this.setState({ wideView: window.innerWidth >= 1580 })
            this.setState({ windowWidth: window.innerWidth });
        }
    }

    render() {
        var desktopTableHeader = "<table>"
            + "<tr>"
            + "<th style='width:200px'>Item</th>"
            + "<th style='width:285px'>Description</th>"
            + "<th style='width:55px'>Status</th>"
            + "<th style='width:35px;text-align: right;'>Qty</th>"
            + "<th style='width:65px;text-align: right;'>B/O Qty</th>"
            + "<th style='width:55px;padding-left:20px;'>Unit</th>"
            + "<th style='width:55px;text-align: right;'>Price</th>"
            + "<th style='width:80px;text-align: right;'>Total</th>"
            + "</tr>";

        if (this.state.mobileView === true || this.state.tabletView === true) {
            desktopTableHeader = "";
        }

        var desktopTableFooter = "</table>";

        if (this.state.mobileView === true || this.state.tabletView === true) {
            desktopTableFooter = "";
        }

        return (
            <div className="order-data-review">
                { Parser(desktopTableHeader) }
                {
                    this.props.orderItems.map(item => {
                        var itemData = item.split(';')[0];
                        var itemId = itemData.split(',')[0];
                        var um = itemData.split(',')[1];

                        var orderData = item.split(';')[1];
                        var description = orderData.split(',')[5].replace('~~', ',').replace('~~', ',').replace('~~', ',').replace('~~', ',').replace('~~', ',');
                        description = description.replace('@', ',').replace('@', ',').replace('@', ',');
                        var status = orderData.split(',')[1];
                        var backOrdered = orderData.split(',')[4];
                        var qty = Number(orderData.split(',')[0]);
                        var price = Number(orderData.split(',')[2]);
                        var subTotal = qty * price;
                        var cost = Number(orderData.split(',')[3]);

                        var rate1Margin = orderData.split(',')[6];
                        var rate2Margin = orderData.split(',')[7];
                        var rate3Margin = orderData.split(',')[8];

                        if (this.state.mobileView === true || this.state.tabletView === true) {
                            return (
                                <li key={itemId + ',' + um} style={{ listStyle: 'none' }}>
                                    <span className='op-review-itemId'><b>{itemId}</b></span><br />
                                    <span className='op-review-description'><b>{description}</b></span><br />
                                    <span className='op-review-status'><b style={{ color: 'steelblue' }}>{status} </b></span>
                                    |
                                <span className='op-review-backordered'><b style={{ color: 'saddlebrown' }}> Back Order: {backOrdered}</b></span><br />
                                    <span className='op-review-qty'><b style={{ color: 'black' }}>Ordered: {qty}</b></span> |&nbsp;
                                <span className='op-review-price'><b style={{ color: 'orange' }}>{price.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></span>&nbsp;
                                <span className='op-review-um'><b style={{ color: 'orange' }}>{um}</b></span> |&nbsp;
                                <span className='op-review-subtotal'><b style={{ color: 'orange' }}> {subTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></span>
                                    <br />

                                    <StarRatingComponent
                                        name="rate1"
                                        editing={false}
                                        value={
                                            cost ?
                                                (price - cost) / price * 100
                                                    >= rate3Margin ?
                                                    3
                                                    :
                                                    (price - cost) / price * 100
                                                        >= rate2Margin ?
                                                        2
                                                        :
                                                        (price - cost) / price * 100
                                                            >= rate1Margin ?
                                                            1
                                                            :
                                                            0
                                                :
                                                0
                                        }
                                        starCount={3}
                                        starColor="#ffb400"
                                        emptyStarColor="#ffb400"
                                        renderStarIcon={(index, value) => {
                                            return (
                                                <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                    <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                                                </span>
                                            );
                                        }}
                                        renderStarIconHalf={() => {
                                            return (
                                                <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                    <span style={{ position: 'absolute' }}><i className="fa fa-star-half-o" /></span>
                                                    <span><i className="fa fa-star-half-o" /></span>
                                                </span>
                                            );
                                        }}
                                    />&nbsp;<span className={this.props.showDetails === true ? '' : 'hidden'}><b style={{ color: 'black' }}>{((price - cost) / price * 100).toFixed(0) + '%'}</b></span>
                                    <br /><br />
                                </li>
                            );
                        } else {
                            return (
                                <tr>
                                    <td key={itemId + ',' + um} style={{ width: '200px' }}>
                                        <span><b>{itemId}</b></span>
                                        <br />

                                        <StarRatingComponent
                                            name="rate1"
                                            editing={false}
                                            value={
                                                cost ?
                                                    (price - cost) / price * 100
                                                        >= rate3Margin ?
                                                        3
                                                        :
                                                        (price - cost) / price * 100
                                                            >= rate2Margin ?
                                                            2
                                                            :
                                                            (price - cost) / price * 100
                                                                >= rate1Margin ?
                                                                1
                                                                :
                                                                0
                                                    :
                                                    0
                                            }
                                            starCount={3}
                                            starColor="#ffb400"
                                            emptyStarColor="#ffb400"
                                            renderStarIcon={(index, value) => {
                                                return (
                                                    <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                        <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                                                    </span>
                                                );
                                            }}
                                            renderStarIconHalf={() => {
                                                return (
                                                    <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                        <span style={{ position: 'absolute' }}><i className="fa fa-star-half-o" /></span>
                                                        <span><i className="fa fa-star-half-o" /></span>
                                                    </span>
                                                );
                                            }}
                                        />&nbsp;<span className={this.props.showDetails === true ? '' : 'hidden'}><b style={{ color: 'black' }}>{((price - cost) / price * 100).toFixed(0) + '%'}</b></span>
                                        <br /><br />
                                    </td>
                                    <td style={{ width: '285px' }}>
                                        <span className='op-review-description'><b>{description}</b></span>
                                    </td>
                                    <td style={{ width: '55px' }}>
                                        <span className='op-review-status'><b style={{ color: 'steelblue' }}>{status} </b></span>
                                    </td>
                                    <td style={{ width: '35px', textAlign: 'right' }}>
                                        <span className='op-review-qty'><b style={{ color: 'black' }}>{qty}</b></span>
                                    </td>
                                    <td style={{ width: '65px', textAlign: 'right' }}>
                                        <span className='op-review-backordered'><b style={{ color: 'saddlebrown' }}>{backOrdered}</b></span>
                                    </td>
                                    <td style={{ width: '55px', paddingLeft: '20px' }}>
                                        <span className='op-review-um'><b style={{ color: 'orange' }}>{um}</b></span>
                                    </td>
                                    <td style={{ width: '55px', textAlign: 'right' }}>
                                        <span className='op-review-price'><b style={{ color: 'orange' }}>{price.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></span>
                                    </td>

                                    <td style={{ width: '80px', textAlign: 'right' }}>
                                        <span className='op-review-subtotal'><b style={{ color: 'orange' }}> {subTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></span>
                                    </td>
                                </tr>
                            );
                        }
                    })
                }
                { Parser(desktopTableFooter) }
            </div>
        )}
}

export default connect(
    state => state.orderPlannerDelivery,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(OrderDataReview);


// WEBPACK FOOTER //
// ./src/components/common/OrderDataReview.js